import type { IMsalContext } from '@azure/msal-react';

import { AUTH_MODE, AuthMode } from '@/config/env';
import { isLoggedInForDemo } from '@/config/msal';
import { hasJwtSession } from '@/lib/auth-token';

export function isSessionAuthenticated(msal: IMsalContext | undefined): boolean {
	if (AUTH_MODE === AuthMode.Real) {
		return hasJwtSession();
	}

	return msal ? isLoggedInForDemo(msal.instance) : false;
}
